module.exports = __webpack_public_path__ + "images/home/product/wechat-miniprogram-device-right-66b707d28dfe6cf43302c4b7b451c129.png";